import { render, staticRenderFns } from "./ShareDialog.vue?vue&type=template&id=45b0cec0"
import script from "./ShareDialog.vue?vue&type=script&lang=js"
export * from "./ShareDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports